'use strict';
import skate from 'skatejs';

var auiSkate = skate.noConflict();

export default auiSkate;



// WEBPACK FOOTER //
// src/js/aui/internal/skate.js